/**
 * 判断是否为有限数
 * @return {Boolean}
 */
import isNumber from './is-number';
export default function (value) {
  return isNumber(value) && isFinite(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-finite.js
// module id = 89
// module chunks = 0